/* src/app/quickbooks/sync-lists/sync-lists.component.scss */
::ng-deep .error {
  color: maroon;
  font-weight: bold;
}
::ng-deep .success {
  color: darkgreen;
  background-color: #d4edda;
  border-radius: 5px;
  padding: 0.2rem;
}
/*# sourceMappingURL=sync-lists.component.css.map */
